import { simplePath } from "../utils.js";
const GET_ORGANIZATION_UNIQUE_NAME_PATH = '/v2/organization/unique-name/:displayName';
function get_organization_uniquer_name_path(params) {
    return simplePath(GET_ORGANIZATION_UNIQUE_NAME_PATH, params);
}
export { GET_ORGANIZATION_UNIQUE_NAME_PATH, get_organization_uniquer_name_path };
